import commonResource from '../../../locales/th/common.json';

export const postCategory = {
  all: 'all',
  review: 'project_review',
  preview: 'project_preview',
  pointOfView: 'point_of_view',
  locationInsight: 'location_insight',
  news: 'news',
  guides: 'guides',
  decor: 'decor',
  video: 'video',
};

export const postAdCategory = {
  [postCategory.all]: '',
  [postCategory.review]: 'project_review',
  [postCategory.preview]: 'project_preview',
  [postCategory.pointOfView]: 'point_of_view',
  [postCategory.locationInsight]: 'location_insight',
  [postCategory.guides]: 'guides',
  [postCategory.news]: 'news',
  [postCategory.decor]: 'decor',
  [postCategory.video]: 'video',
};

export const anchorContentTitle: Record<string, string> = {
  fact_sheet: 'ข้อมูลโครงการ',
  location: 'ทำเลที่ตั้ง',
  project: 'รายละเอียดโครงการ',
  pwt_house: 'แบบบ้าน',
  pwt_condo: 'แบบห้อง',
  pwt_other: 'แบบแปลน',
  price_condition: 'ราคา',
  conclusion: 'บทสรุป',
  lead_form_nav_btn: 'ลงทะเบียนรับสิทธิพิเศษ',
};

export const anchorContentTitleEnglish: Record<string, string> = {
  ข้อมูลโครงการ: 'Fact sheet',
  ทำเลที่ตั้ง: 'Location',
  รายละเอียดโครงการ: 'Project',
  แบบบ้าน: 'Product Walk Through - House & Townhome',
  แบบห้อง: 'Product Walk Through - Condo',
  แบบแปลน: 'Product Walk Through - All other PT',
  ราคา: 'Price and condition',
  บทสรุป: 'Conclusion',
  ลงทะเบียนรับสิทธิพิเศษ: 'Lead Form Nav Btn',
};

export enum PostMainCategory {
  ProjectResearch = 'project_research',
  Guides = 'guides',
  LocationInsight = 'location_insight',
  News = 'news',
  Decor = 'decor',
}

export enum PostSubcategory {
  Review = 'project_review',
  Preview = 'project_preview',
  PointOfView = 'point_of_view',
  LocationInsight = 'location_insight',
  BuyAndSell = 'buy_and_sell',
  Rent = 'rent',
  Investment = 'investment',
  Finance = 'finance',
  PropertyNews = 'property_news',
  GeneralNews = 'general_news',
  InteriorInspiration = 'interior_inspiration',
  Renovation = 'renovation',
  Maintenance = 'maintenance',
}

export type PropertyResearchPostCategory =
  | PostSubcategory.Review
  | PostSubcategory.Preview
  | PostSubcategory.PointOfView;

export type NewsPostSubCategory =
  | PostSubcategory.PropertyNews
  | PostSubcategory.GeneralNews;

export type GuidesSubCategory =
  | PostSubcategory.BuyAndSell
  | PostSubcategory.Investment
  | PostSubcategory.Finance;

export type DecorSubCategory =
  | PostSubcategory.InteriorInspiration
  | PostSubcategory.Renovation
  | PostSubcategory.Maintenance;

const categoryThaiResourceMap = new Map<PostSubcategory, string>([
  [
    PostSubcategory.Review,
    commonResource.postCategories.projectResearch.review,
  ],
  [
    PostSubcategory.Preview,
    commonResource.postCategories.projectResearch.preview,
  ],
  [
    PostSubcategory.PointOfView,
    commonResource.postCategories.projectResearch.pov,
  ],
  [PostSubcategory.BuyAndSell, commonResource.postCategories.guides.buyAndSell],
  [PostSubcategory.Rent, commonResource.postCategories.guides.rent],
  [PostSubcategory.Investment, commonResource.postCategories.guides.investment],
  [PostSubcategory.Finance, commonResource.postCategories.guides.finance],
  [
    PostSubcategory.PropertyNews,
    commonResource.postCategories.news.propertyNews,
  ],
  [PostSubcategory.GeneralNews, commonResource.postCategories.news.generalNews],
  [
    PostSubcategory.LocationInsight,
    commonResource.postCategories.locationInsight.locationInsight,
  ],
  [
    PostSubcategory.InteriorInspiration,
    commonResource.postCategories.decor.interiorInspiration,
  ],
  [PostSubcategory.Renovation, commonResource.postCategories.decor.renovation],
  [
    PostSubcategory.Maintenance,
    commonResource.postCategories.decor.maintenance,
  ],
]);

const mainCategoryToSubCategoryMap: Map<PostMainCategory, PostSubcategory[]> =
  new Map([
    [
      PostMainCategory.ProjectResearch,
      [
        PostSubcategory.Review,
        PostSubcategory.Preview,
        PostSubcategory.PointOfView,
      ],
    ],
    [
      PostMainCategory.Guides,
      [
        PostSubcategory.BuyAndSell,
        PostSubcategory.Rent,
        PostSubcategory.Investment,
        PostSubcategory.Finance,
      ],
    ],
    [PostMainCategory.LocationInsight, [PostSubcategory.LocationInsight]],
    [
      PostMainCategory.News,
      [PostSubcategory.PropertyNews, PostSubcategory.GeneralNews],
    ],
    [
      PostMainCategory.Decor,
      [
        PostSubcategory.InteriorInspiration,
        PostSubcategory.Renovation,
        PostSubcategory.Maintenance,
      ],
    ],
  ]);

const subCategoryToMainCategoryMap: Map<PostSubcategory, PostMainCategory> =
  new Map(
    [].concat(
      ...Array.from(mainCategoryToSubCategoryMap).map(
        ([mainCategory, subCategories]) =>
          subCategories.map(
            (subCategory): [PostSubcategory, PostMainCategory] => [
              subCategory,
              mainCategory,
            ],
          ),
      ),
    ),
  );

export const getSubcategories = (
  mainCategory: PostMainCategory,
): PostSubcategory[] => mainCategoryToSubCategoryMap.get(mainCategory) || [];

export function getMainCategory(
  subcategory: PostSubcategory,
): PostMainCategory {
  return subCategoryToMainCategoryMap.get(subcategory);
}

export const getPostCategoryInThai = (postCategory: PostSubcategory): string =>
  categoryThaiResourceMap.get(postCategory);
